import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const Datenschutz = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <nav className="text-sm text-gray-500 mb-8" aria-label="Breadcrumb">
            <ol className="flex items-center gap-2">
              <li><Link to="/" className="hover:text-[#0088cc] transition-colors">Startseite</Link></li>
              <li aria-hidden="true">›</li>
              <li className="text-gray-800">Datenschutzerklärung</li>
            </ol>
          </nav>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">Datenschutzerklärung</h1>
          <p className="text-gray-500 text-sm mb-10">Stand: Mai 2025</p>

          <div className="space-y-10 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Datenschutz auf einen Blick</h2>
              <h3 className="font-medium text-gray-800 mb-2">Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen
                Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen
                Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz
                entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">2. Verantwortlicher</h2>
              <address className="not-italic mb-3">
                <strong>Konstantin Florian Kalla</strong><br />
                3D-Druck Potsdam<br />
                Brauerstraße 1<br />
                14467 Potsdam<br />
                E-Mail:{" "}
                <a
                  href="mailto:konstantin.florian.kalla@3d-druck-potsdam.de"
                  className="text-[#0088cc] hover:underline"
                >
                  konstantin.florian.kalla@3d-druck-potsdam.de
                </a>
              </address>
              <p>
                Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist die oben genannte Person.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">3. Datenerfassung auf dieser Website</h2>

              <h3 className="font-medium text-gray-800 mt-4 mb-2">Server-Log-Dateien</h3>
              <p className="mb-3">
                Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten
                Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies sind:
              </p>
              <ul className="list-disc list-inside space-y-1 mb-3 text-sm">
                <li>Browsertyp und Browserversion</li>
                <li>Verwendetes Betriebssystem</li>
                <li>Referrer URL</li>
                <li>Hostname des zugreifenden Rechners</li>
                <li>Uhrzeit der Serveranfrage</li>
                <li>IP-Adresse (anonymisiert)</li>
              </ul>
              <p>
                Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Grundlage für die Datenverarbeitung
                ist Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen).
              </p>

              <h3 className="font-medium text-gray-800 mt-6 mb-2">Kontaktformular und E-Mail-Anfragen</h3>
              <p>
                Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus dem
                Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage
                und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre
                Einwilligung weiter. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) bzw.
                Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen).
              </p>

              <h3 className="font-medium text-gray-800 mt-6 mb-2">Datei-Uploads (STL-Dateien)</h3>
              <p>
                Wenn Sie Dateien (z. B. STL-Modelle) zur Anfragenerstellung hochladen, werden diese Dateien
                ausschließlich zur Bearbeitung Ihrer Anfrage verarbeitet und nach Abschluss des Auftrages gelöscht.
                Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Analyse-Tools: Google Analytics</h2>
              <p className="mb-3">
                Diese Website nutzt Google Analytics 4 (GA4), einen Webanalysedienst der Google LLC
                (1600 Amphitheatre Parkway, Mountain View, CA 94043, USA; „Google"). Google Analytics verwendet
                sogenannte „Cookies", Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse
                der Benutzung der Website ermöglichen.
              </p>
              <p className="mb-3">
                Wir haben IP-Anonymisierung aktiviert, sodass Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten
                der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen
                Wirtschaftsraum vor der Übermittlung in die USA gekürzt wird.
              </p>
              <p className="mb-3">
                Sie können die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie das
                Browser-Add-On zur Deaktivierung von Google Analytics herunterladen und installieren:
                {" "}<a
                  href="https://tools.google.com/dlpage/gaoptout?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#0088cc] hover:underline"
                >
                  https://tools.google.com/dlpage/gaoptout
                </a>
              </p>
              <p>
                Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO. Näheres zur Datenverarbeitung durch Google finden
                Sie in den Google-Datenschutzbestimmungen:{" "}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#0088cc] hover:underline"
                >
                  https://policies.google.com/privacy
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">5. Ihre Rechte</h2>
              <p className="mb-3">
                Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen
                Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf
                Berichtigung, Sperrung oder Löschung dieser Daten (Art. 15–22 DSGVO).
              </p>
              <p className="mb-3">
                Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der
                im Impressum angegebenen Adresse an uns wenden.
              </p>
              <p className="mb-3">
                Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu:
              </p>
              <address className="not-italic text-sm bg-gray-100 p-4 rounded-lg">
                <strong>Landesbeauftragte für den Datenschutz und für das Recht auf Akteneinsicht Brandenburg</strong><br />
                Stahnsdorfer Damm 77<br />
                14532 Kleinmachnow<br />
                Telefon: +49 (0) 33203 356-0<br />
                E-Mail: poststelle@lda.brandenburg.de
              </address>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Datensicherheit</h2>
              <p>
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte
                (z. B. Anfragen, die Sie an uns als Seitenbetreiber senden) eine SSL- bzw. TLS-Verschlüsselung.
                Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://"
                auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Datenschutz;
